import * as React from "react";
import { TextInput } from "@montana/shared/form";
import { Translate } from "@montana/shared/translate";
import { useTranslations } from "@montana/containers/translations";

export interface IProductReference {
    value?: string;
    onChange?: (val: string) => void;
}

export const ProductReference: React.FC<IProductReference> = ({ value, onChange }: IProductReference): JSX.Element => {
    const translate = useTranslations();

    return (
        <div className="product-reference flex flex-col">
            <h3 className="font-pro-bold text-base leading-5 xl:leading-6 mb-3">
                <Translate value={(t): string => t.checkoutPage.productRef} defaultValue="Product ref:"></Translate>
            </h3>
            <TextInput
                maxLength={30}
                aria-label={translate((t): string => t.checkoutPage.productRef, "Product ref:")}
                onChange={(e) => onChange && onChange(e.target.value)} value={value} />
        </div>
    )
};
